module.exports = __webpack_public_path__ + "img/8.d1b92048.jpg";